import { useEffect, useState } from "react";
import { X, ChevronDown, Video } from 'lucide-react';

const ViewRomTestModal = ({ data, onClose, onOpenViewer }) => {
    console.log("data", data)
    const [sessionName, setSessionName] = useState(data?.title || '');
    const [sessionDescription, setSessionDescription] = useState(data?.description || '');
    const [exercises, setExercises] = useState([]);

    useEffect(() => {
        const raw = data?.activity_data?.length > 0
            ? data.activity_data
            : data.exercises || [];

        const initialized = raw.map((ex, idx) => ({
            ...ex,
            name: ex.name || ex.display_name || `Exercise #${idx + 1}`,
            reps: ex.reps || 8,
            hold: ex.hold_in_seconds || 0,
            set_limb_instruction:
                typeof ex.set_limb_instruction === "string"
                    ? ex.set_limb_instruction?.length > 0
                        ? { name: ex.set_limb_instruction }
                        : null
                    : ex.set_limb_instruction || null,
            limb_instructions: ex.limb_instructions || [],
            videoUrl: ex.video || '',
        }));

        setExercises(initialized);
    }, [data]);

    return (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[60] animate-fade-in-up">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[95vw] sm:max-w-5xl p-6 transform transition-all flex flex-col max-h-[90vh]">

                {/* Header */}
                <div className="flex justify-between items-center mb-4 border-b pb-4">
                    <h2 className="text-2xl font-bold text-gray-800">{sessionName}</h2>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200 transition">
                        <X size={24} />
                    </button>
                </div>

                {/* Exercise List */}
                <div className="flex-grow overflow-y-auto pr-2">
                    {exercises.length === 0 ? (
                        <div className="text-center text-gray-500 py-10">No ROM exercises found.</div>
                    ) : (
                        <div className="flex flex-col gap-2">
                            {exercises?.filter(
                                (ex, index, self) =>
                                    index === self.findIndex((e) => e.set_id === ex.set_id)
                            )?.map((ex, idx) => (
                                <div key={idx} className="flex items-center gap-4 p-3 border rounded-lg bg-gray-50 justify-between">
                                    <div className="flex-1 font-semibold text-gray-800 min-w-[150px]">
                                        {ex.name}
                                    </div>

                                    <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-5 gap-2 items-start flex-1 text-sm">

                                        {/* STATUS */}
                                        <div>
                                            <span className="block text-gray-500 mb-1">Status:</span>
                                            <div className="text-gray-800">
                                                {
                                                    ex.is_complete
                                                        ? 'Completed'
                                                        : ex.is_skipped
                                                            ? 'Skipped'
                                                            : 'Pending'
                                                }
                                            </div>
                                        </div>

                                        {/* Sets */}
                                        <div>
                                            <span className="block text-gray-500 mb-1">Sets:</span>
                                            <div className="text-gray-800">
                                                {exercises.filter(e => e.set_id === ex.set_id)?.length}
                                            </div>
                                        </div>

                                        {/* Reps */}
                                        <div>
                                            <span className="block text-gray-500 mb-1">Reps:</span>
                                            <div className="text-gray-800">{ex.reps}</div>
                                        </div>

                                        {/* Hold */}
                                        <div>
                                            <span className="block text-gray-500 mb-1">Hold (s):</span>
                                            <div className="text-gray-800">{ex.hold || 0}</div>
                                        </div>

                                        {/* Limb */}
                                        <div>
                                            <span className="block text-gray-500 mb-1">Limb:</span>
                                            <div className="text-gray-800">
                                                {ex.set_limb_instruction?.name || "N/A"}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Video Viewer */}
                                    {/* {ex.videoUrl && (
                                        <div className="ml-4">
                                            <button
                                                onClick={() =>
                                                    onOpenViewer({
                                                        ...ex,
                                                        title: ex.name,
                                                        content: ex.videoUrl,
                                                        category: 'Video'
                                                    })
                                                }
                                                className="text-[#166273] hover:text-[#166273]/90 transition"
                                            >
                                                <Video size={20} />
                                            </button>
                                        </div>
                                    )} */}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ViewRomTestModal;
